import BaseModule from './BaseModule'

class CommonManager extends BaseModule {
  constructor() {
    super()
  }

  siteInfo() {
    return this.get('/site/info').then(result => result.data)
  }

  message(params) {
    return this.get('/api/message/index?expand=managers', {
      params
    }).then(result => result.data)
  }

  //消息通知
  count() {
    return this.get('/api/message/count').then(result => {
        return result.data
    })
  }

  //最近的未阅读的消息
  notify() {
    return this.get('/api/message/notify').then(result => result.data)
  }

  read(id) {
    return this.post('/api/message/read', { id }).then(result => result.data)
  }

  readAll() {
    return this.post('/api/message/read-all').then(result => result.data)
  }

  menus() {
    return this.get('/api/common/menus').then(result => result.data )
  }

  permissions() {
    return this.get('/api/common/permissions').then(result => result.data)
  }

  departManager(id) {
    return this.get('/api/common/depart-managers', {
      params: {
        id
      }
    }).then(result => result.data)
  }

  tags() {
    return this.get('/api/common/tags').then(result => result.data)
  }

  industrys() {
    return this.get('/api/common/industrys').then(result => result.data)
  }

  departs() {
    return this.get('/api/common/departs').then(result => result.data)
  }
  departsAll() {
    return this.get('/api/department/list').then(result => result.data)
  }

  indexDeparts() {
    return this.get('/api/common/departs', {
      params: {
        sale : 1
      }
    }).then(result => result.data)
  }
  coralDeparts() {
    return this.get('/api/sale-plan/depart-list').then(result => result.data)
  }

  managers() {
    return this.get('/api/common/managers').then(result => result.data)
  }

  qiniuToken() {
    return this.post('/api/common/qiniu-token').then(result => result.data)
  }

  siteConfig() {
    return this.post('/api/common/site-config').then(result => result.data)
  }

  departPlan(params) {
    return this.get('/api/sale-plan/depart?expand=department,manager', { params }).then(result => result.data)
  }

  managerPlan(params){
    return this.get('/api/sale-plan/manager?expand=department,manager', { params }).then(result => result.data)
  }

  saveDepartPlan(data) {
    return this.post('/api/sale-plan/save-depart', data).then(result => result.data)
  }

  savePersonPlan(data){
    return this.post('/api/sale-plan/save-person', data).then(result => result.data)
  }

  saveDepartPlan(data){
    return this.post('/api/sale-plan/save-depart', data).then(result => result.data)
  }

  initDepartPlan(year) {
    return this.post('/api/sale-plan/init-depart', { year }).then(result => result.data)
  }

  initPersonPlan(data){
    return this.post('/api/sale-plan/init-person', data ).then(result => result.data)
  }
  managerDataSet(data){
    return this.post('/api/site-config/save', data).then(result => result.data)
  }
  managerDataGet(){
    return this.post('/api/site-config/index').then(result => result.data)
  }
  setReadStatus(id){
    return this.post('/api/message/read',id).then(result => result.data)
  }

  //发送验证码
  sendCode(phone) {
    return this.post('/api/mobile/send-captcha', {
      phone
    }).then(result => result.data)
  }
  saveReacive(data) {
    return this.post('/api/feedback/save', data).then(result => result.data)
  }

}
export default new CommonManager()



// WEBPACK FOOTER //
// ./src/api/CommonManager.js